import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApprovalStatus } from '@app/domain/model/approval-status';

@Injectable({
  providedIn: 'root'
})
export class SetStatusService {


  constructor(private readonly http: HttpClient) {
  }

  setStatus(reportId: number, status: ApprovalStatus) {
    const params = {
      status: status.toString()
    };
    const requestBody = JSON.stringify(status.toString());

    return this.http
      .put(`reports/${reportId}/status/`, requestBody, { headers: { 'Content-Type': 'application/json' } });
  }
}
